import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./RoomCard.css";
import { PostData } from "../../services/PostData";
import Swal from "sweetalert2";

import subastaRoomIcon from "../../images/subastaRoomIcon.png";
import classicRoomIcon from "../../images/classicRoomIcon.png";
import publicRoomIcon from "../../images/publicRoomIcon.svg";
import tomyPopUp from "../../images/tomyPopUp.png";

class RoomCard extends Component {
  constructor(props) {
    super(props);
    //console.log('datos ficha:',this.props.roomData);
    const roomData = { ...this.props.roomData };
    this.state = { ...roomData };
    console.log("roomdata: ", this.state.roomData);
    this.getMatchData = this.getMatchData.bind(this);
    this.copyRoomLink = this.copyRoomLink.bind(this);
    this.setMatchStatusText = this.setMatchStatusText.bind(this);
  }

  componentDidMount() {
    this.getMatchData();
  }

  getMatchData() {
    let postData = {
      match_id: this.state.match_id,
    };
    PostData("getMatchData", postData).then((result) => {
      let responseJson = result;
      let matchData = responseJson.matchData[0];
      this.setState(
        {
          matchName: matchData.name,
          matchDate: matchData.date,
          matchHour: matchData.hour,
        },
        () => {
          this.setMatchStatusText();
        },
      );
      this.setState({ loading: false });
    });
  }

  setMatchStatusText() {
    if (this.state.status === "1") {
      this.setState({ matchStatusText: "Activa" }, () => {
        //console.log(this.state.matchStatusText);
      });
    }
    if (this.state.status === "4") {
      this.setState({ matchStatusText: "Cerrada" }, () => {
        //console.log(this.state.matchStatusText);
      });
    }
  }

  copyRoomLink() {
    let roomLink = `https://app.subastafutbolera.com/rooms/${this.state.sku}`;
    Swal.fire({
      imageUrl: tomyPopUp,
      imageWidth: 85,
      imageHeight: 130,
      title: "¡Comparte tu sala!",
      html: `
        <p style="color:#555;margin-bottom:16px;">Invita a tus amigos y que empiece la subasta</p>
        <div style="display:flex;align-items:center;border:1px solid #ccc;border-radius:8px;padding:10px 12px;background:#f9f9f9;gap:10px;">
          <span style="flex:1;word-break:break-all;font-size:14px;color:#333;">${roomLink}</span>
          <button id="swal-copy-btn" style="background-color:#16A64A;color:white;border:none;border-radius:20px;padding:8px 20px;font-size:14px;font-weight:bold;cursor:pointer;white-space:nowrap;transition:all 0.3s ease;display:flex;align-items:center;gap:6px;">Copiar</button>
        </div>
        <p style="color:#888;margin-top:16px;font-size:13px;">Pega el link en tus redes sociales favoritas</p>
      `,
      showConfirmButton: false,
      showCloseButton: true,
      position: "top",
      onOpen: () => {
        const copyBtn = document.getElementById("swal-copy-btn");
        if (!copyBtn) return;
        copyBtn.addEventListener("click", function () {
          const tempInput = document.createElement("textarea");
          tempInput.value = roomLink;
          tempInput.style.position = "fixed";
          tempInput.style.opacity = "0";
          document.body.appendChild(tempInput);
          tempInput.select();
          try {
            document.execCommand("copy");
          } catch (e) {
            navigator.clipboard.writeText(roomLink);
          }
          document.body.removeChild(tempInput);
          copyBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> Copiado!';
          copyBtn.style.backgroundColor = "#0d8a3a";
          copyBtn.style.transform = "scale(1.05)";
          setTimeout(function () {
            copyBtn.style.transform = "scale(1)";
          }, 200);
        });
      },
    });
  }

  render() {
    //const roomData = {...this.props.roomData};

    return (
      <div className="subasta-room-container">
        <div className="subasta-room-header">
          {this.state.type_room === "1" && (
            <>
              <div className="subasta-room-type-icon">
                <img src={subastaRoomIcon} alt="Sala tipo Subasta" />
              </div>
              <div className="subasta-room-type-title">SUBASTA</div>
            </>
          )}
          {this.state.type_room === "2" && (
            <>
              <div className="subasta-room-type-icon">
                <img src={classicRoomIcon} alt="Sala tipo Subasta" />
              </div>
              <div className="subasta-room-type-title">CLÁSICA</div>
            </>
          )}
          {this.state.type_room === "5" && (
            <>
              <div className="subasta-room-type-icon">
                <img src={publicRoomIcon} alt="Sala tipo Subasta" />
              </div>
              <div className="subasta-room-type-title">PÚBLICA</div>
            </>
          )}
          <div className="subasta-room-status">
            {this.state.matchStatusText}
          </div>
        </div>
        <div className="subasta-room-match-name-container">
          <div className="subasta-room-match-name">{this.state.name}</div>
        </div>
        <div className="subasta-room-data-container">
          <div className="subasta-romm-data-row">
            <div className="subasta-room-data-title">PARTIDO:</div>
            <div className="subasta-room-data-field">
              {this.state.matchName}
            </div>
          </div>
          <div className="subasta-romm-data-row">
            <div className="subasta-room-data-title">FECHA:</div>
            <div className="subasta-room-data-field">
              {this.state.matchDate} - {this.state.matchHour}
            </div>
          </div>
          <div className="subasta-romm-data-row">
            <div className="subasta-room-btn-container">
              <Link
                to={"/Rooms/" + this.state.sku}
                className="btn btn-primary-small"
              >
                VER SALA
              </Link>
            </div>
            <div className="subasta-room-btn-container">
              <div
                className="btn btn-primary-small"
                onClick={this.copyRoomLink}
              >
                COMPARTIR
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RoomCard;
